import { AngularJsServiceUpgradeType, ANGULARJS_SERVICE_UPGRADE_TOKENS } from "./angularjs-service-upgrade.enum";

function smartServiceDeliveryFactory(injector: any) {
  return injector.get(AngularJsServiceUpgradeType.SMART_SERVICE_DELIVERY);
}

function rootScopeFactory(injector: any) {
  return injector.get(AngularJsServiceUpgradeType.ROOT_SCOPE);
}

function stateFactory(injector: any) {
  return injector.get(AngularJsServiceUpgradeType.STATE);
}

//this provider should be included in NgModule, where service needs to be used
export const smartServiceDeliveryProvider = {
  provide: ANGULARJS_SERVICE_UPGRADE_TOKENS.SMART_SERVICE_DELIVERY_TOKEN,
  useFactory: smartServiceDeliveryFactory,
  deps: ['$injector']
};

export const rootScopeProvider = {
  provide: ANGULARJS_SERVICE_UPGRADE_TOKENS.ROOT_SCOPE_TOKEN,
  useFactory: rootScopeFactory,
  deps: ['$injector']
};

export const stateProvider = {
  provide: ANGULARJS_SERVICE_UPGRADE_TOKENS.STATE_TOKEN,
  useFactory: stateFactory,
  deps: ['$injector']
};